export default __webpack_public_path__ + "static/media/luna.f7eafdea.png";